export const isPermissionAllowed = (allowedPermissions,selectedApp,permissions) => {

  if (selectedApp == "CGM") {
    return true
  }

  if (permissions.length == 0) {
    return true;
  }
  if (allowedPermissions.some((ap) => permissions.includes(ap))) {
    return true;
    } 
    

    return false
    
    
};